import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BulletList } from "react-content-loader";
import { cLoading } from "../../../utils/utils";
import NotificationsHeader from "../NotificationsHeader";
import Nothing from "../nothing";
import End from "../end";
import "../notification.scss";
import NotificationList from "./NotificationList";
import {
  getNotificationsAction,
} from "../actions/notification-actions";
import { connect } from "react-redux";

const Notifications = (props) => {
  const { getNotificationList, notificationList, showLoader } = props;
  const [notifications, setNotifications] = useState([]);

  const map_notifications =
    notifications.length !== 0 &&
    notifications.map((n) => {
      return (
        <NotificationList
          key={n.id}
          {...n}
          setNotifications={setNotifications}
        />
      );
    });

  useEffect(() => {
    getNotificationList();
  }, []);

  useEffect(() => {
    setNotifications(notificationList);
  }, [notificationList]);

  return (
    <div className="notification-container">
      {showLoader && (
        <div style={{ margin: "0 0 0 25%" }}>
          <BulletList />
        </div>
      )}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className={cLoading(showLoader)}
      >
        <div className="notifications_div">
          <NotificationsHeader
            len={notificationList ? notificationList.length : 0}
          />
          {notificationList && notificationList.length == 0 ? (
            <Nothing />
          ) : (
            map_notifications
          )}
          {notificationList && notificationList.length != 0 && <End />}
        </div>
      </motion.div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  notificationList: state.Notifications.notificationList,
  showLoader: state.Notifications.showLoader,
});

const mapDispatchToProps = (dispatch) => ({
  getNotificationList: () => dispatch(getNotificationsAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
